var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignsEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.6665 10.8499C6.26884 18.6277 13.7308 18.6277 18.3332 10.8499C13.7308 3.07216 6.26884 3.07216 1.6665 10.8499ZM9.99984 13.3499C8.61909 13.3499 7.49984 12.2307 7.49984 10.8499C7.49984 9.46916 8.61909 8.34991 9.99984 8.34991C11.3806 8.34991 12.4998 9.46916 12.4998 10.8499C12.4998 12.2307 11.3806 13.3499 9.99984 13.3499Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsEye);
export default __webpack_public_path__ + "static/media/campaigns-eye.16799cecdb99ede149d28d224f19835f.svg";
export { ForwardRef as ReactComponent };